import { ResponsiveImage, LazyLoadImages, ResponsiveHeroImage } from "@quintype/components";
import React from "react";
export const renderResponsiveImage = (slug, alt, defaultWidth = 100, quality = 75) => {
  return (
    <LazyLoadImages>
      <ResponsiveImage
        slug={slug}
        aspect-ratio={[3, 1]}
        defaultWidth={defaultWidth}
        imgParams={{ auto: ["format", "compress"], q: quality, fm: "webp" }}
        alt={alt}
      />
    </LazyLoadImages>
  );
};

export const ResponsiveBannerImage = ({
  slug,
  alt,
  loading = "lazy",
  quality = 75,
  width = "610",
  fetchpriority,
  isZoom = false,
}) => {
  // Use srcset for responsive images to avoid loading multiple sizes
  const baseUrl = `https://swarajya.gumlet.io/${slug}`;

  // For zoom/desktop views, include larger sizes. For regular images, limit to prevent mobile from loading oversized images
  const srcSet = isZoom
    ? [
        `${baseUrl}?w=610&q=${quality}&compress=true&format=auto 610w`,
        `${baseUrl}?w=1220&q=${quality}&compress=true&format=auto 1220w`,
      ].join(", ")
    : [
        `${baseUrl}?w=310&q=${quality}&compress=true&format=auto 310w`,
        `${baseUrl}?w=610&q=${quality}&compress=true&format=auto 610w`,
      ].join(", ");

  // More specific sizes to prevent loading oversized images on mobile
  // Mobile (≤640px): max 310px, but with 2x DPR = 620px needed, so 610px is sufficient
  // Desktop (>640px): max 610px, but with 2x DPR = 1220px needed, but we only provide 610px for non-zoom
  const sizes = isZoom ? "(max-width: 1024px) 610px, 1220px" : "(max-width: 640px) 310px, 610px";

  return (
    <div>
      {loading === "eager" ? (
        <img
          src={`${baseUrl}?w=${width}&q=${quality}&compress=true&format=auto`}
          srcSet={srcSet}
          sizes={sizes}
          alt={alt}
          loading={loading}
          fetchpriority={fetchpriority}
          style={{
            aspectRatio: 3 / 1,
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
          width={width}
          height={Math.round(parseInt(width) / 3)}
        />
      ) : (
        <LazyLoadImages>
          <img
            src={`${baseUrl}?w=${width}&q=${quality}&compress=true&format=auto`}
            // srcSet={srcSet}
            // sizes={sizes}
            alt={alt}
            loading={loading}
            style={{
              aspectRatio: 3 / 1,
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
            width={width}
            height={Math.round(parseInt(width) / 3)}
          />
        </LazyLoadImages>
      )}
    </div>
  );
};
